module.exports = __webpack_public_path__ + "img/AT0000002645982.f7b0f3e3.png";